'use client'

// Component Imports
import DashboardResume from '@/views/dashboards/resume'

const ResumePage = () => {
  return <DashboardResume />
}

export default ResumePage
